// Used in date, callInfo formatters
export const DEFAULT_DATE_SEPARATOR = '/'
// Used in filter values
export const SHOW_EMPTY_CELLS = '__showEmptyCells'
